import { requestWithToken } from '../utilities/request';

// 振興局マスタ情報(労安項目)取得API
const list = () => {
  return requestWithToken({
    method: 'GET',
    url: '/api/private/regional_development_bureaux/list',
  });
};

export const RegionalDevelopmentBureauxService = {
  list,
};



// WEBPACK FOOTER //
// ./src/services/RegionalDevelopmentBureaux.js